import { render, staticRenderFns } from "./FileNameViewer.vue?vue&type=template&id=56d7ab0e&scoped=true"
import script from "./FileNameViewer.vue?vue&type=script&lang=js"
export * from "./FileNameViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d7ab0e",
  null
  
)

export default component.exports